import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'
import Select from '../../../../molecules/Select'
import Icon from '../../../../atoms/Icon'

function ClientTagSelect ({ groupType, formValues, setFormValues }) {
  const value = useMemo(() => {
    console.log('client tag select', groupType.longName, formValues)
    return formValues.groups.find(x => x.groupTypeId === groupType.groupTypeId)?.groupId
  }, [groupType, formValues])
  const setValue = useCallback((val) => {
    setFormValues(prev => {
      const newGroups = [...prev.groups]
      const gtIndex = newGroups.findIndex(x => x.groupTypeId === groupType.groupTypeId)
      newGroups[gtIndex] = { ...newGroups[gtIndex], groupId: val }

      return {
        ...prev,
        groups: newGroups
      }
    })
  }, [setFormValues, groupType])

  return (
    <div className='__select-group'>
      <Select
        className='__select-option'
        value={value}
        options={groupType.options}
        showCheckMarOnSelectedItems
        onChange={setValue}
      />
      <Button
        disabled={!value}
        className='__remove-button'
        startIcon={<Icon name='close' />}
        onClick={() => setValue(null)}
      >
        Clear
      </Button>
    </div>
  )
}

ClientTagSelect.propTypes = {
  groupType: PropTypes.shape({
    groupTypeId: PropTypes.number,
    options: PropTypes.array,
    longName: PropTypes.string
  }),
  formValues: PropTypes.object,
  setFormValues: PropTypes.func
}

export default ClientTagSelect
